import iconSquareArrowDown from '@/assets/images/icons/icon-square-arrow-down.png';
import iconSquareArrowUp from '@/assets/images/icons/icon-square-arrow-up.png';
import Accordion from '@/components/ui/Accordion/Accordion';
import { sendFaqAccordionClickEvent } from '@/utils/ga';
import { useSession } from 'next-auth/react';
import styles from './FaqDetailAccordion.module.scss';

function FaqDetailAccordion({
  isOpen,
  setIsOpen,
  faqDetailDescription,
  title,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  faqDetailDescription: string;
  title: string;
}) {
  const session = useSession();
  const handleClick = () => {
    setIsOpen(!isOpen);

    // GAイベント送信
    const userId = session?.data?.user.id ?? 0;
    sendFaqAccordionClickEvent(title, userId);
  };

  return (
    <>
      <div
        className={styles.productDetail}
        onClick={handleClick}
        data-testid={`faq-question-${title.replace(/\s+/g, '-').toLowerCase()}`}
      >
        <p className={styles.productDetailTitle}>{title}</p>
        <img
          src={isOpen ? iconSquareArrowUp.src : iconSquareArrowDown.src}
          alt='icon-square-arrow-down'
          className={styles.productDetailIcon}
        />
      </div>
      <Accordion isOpened={isOpen}>
        <div className={styles.content}>
          <div className={styles.description}>
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
            <div dangerouslySetInnerHTML={{ __html: faqDetailDescription }} />
          </div>
        </div>
      </Accordion>
    </>
  );
}

export default FaqDetailAccordion;
